const activityPanelStyles = (theme) => ({
  activityPanel_content: {
    padding: '0 20px 10px',
  },
  textFieldSupplement: {
    fontSize: '1rem',
  },
  muiTextField: {
    width: '100%',
  },
  u_alignRight: {
    textAlign: 'right',
  },
});

export default activityPanelStyles;
